import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import GradeAndSpec from '../../containers/grade-and-spec';
import GradeAndSpecData from '../../blocks/grade-and-spec-data';

const GradeAndSpecBlock = props => <GradeAndSpec {...props} />;
GradeAndSpecBlock.displayName = 'GradeAndSpec';

export default withDynamicComponents({
  componentWhitelist: [
    GradeAndSpecData,
  ],
  mapInputToOutput: [
    ['gradeAndSpecData', 'gradeAndSpecData'],
  ],
})(GradeAndSpecBlock);



// WEBPACK FOOTER //
// ./src/blocks/grade-and-spec/index.jsx